import { Directive } from "@angular/core";
import { NzRadioButtonDirective } from "ng-zorro-antd/radio";

@Directive({
  selector: "[ui-radio-button]",
})
export class UiRadioButtonDirective extends NzRadioButtonDirective {}
